import { MergedTableDto } from 'gleblu-socket-api';

import MergedTable from '../interfaces/layout/MergedTable';

export function fromDto(mergedTableDto: MergedTableDto): MergedTable {
  const { uuid, layoutUuid, tableUuids, label, capacity } = mergedTableDto;
  return {
    uuid,
    layoutUuid,
    tableUuids,
    capacity,
    label,
  };
}

export function toDto(mergedTable: MergedTable): MergedTableDto {
  const { uuid, layoutUuid, label, capacity, tableUuids } = mergedTable;
  return {
    uuid,
    layoutUuid,
    label,
    capacity,
    tableUuids,
  };
}
